import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Locale } from 'vant'
// 引入组件的语言包
import zhCN from 'vant/es/locale/lang/zh-CN'
import enUS from 'vant/es/locale/lang/en-US'
import frFR from 'vant/es/locale/lang/fr-FR'
import deDE from 'vant/es/locale/lang/de-DE'
import esES from 'vant/es/locale/lang/es-ES'
// 引入业务自定义的语言包
const localCN = require('./locale/zh') // 简体
const localUS = require('./locale/en') // English
const localFR = require('./locale/fr') // 法语
const localDE = require('./locale/de') // 德语
const localES = require('./locale/es') // 西班牙语
const localIT = require('./locale/it') // 意大利语
// 在这里引入moment了，所以不在main.js引入了
import Moment from 'moment'
Vue.prototype.$moment = Moment
Vue.use(VueI18n);

// 语言包的类型合并
const messages = {
    'zh': { ...zhCN, ...localCN },
    'en': { ...enUS, ...localUS },
    'fr': { ...frFR, ...localFR },
    'de': { ...deDE, ...localDE },
    'es': { ...esES, ...localES },
    'it': { ...localIT },
}

// localStorage获取当前语言类型(初次本地不存在'lang'字段存储，默认设置为'zh')
localStorage.setItem('lang', 'en')
const lang = 'en'

// 初次加载的语言默认设置
Locale.use(lang, messages[lang])
// 时间类moment语言默认设置
Moment.locale(lang)

export default new VueI18n({
    locale: lang, // set locale 
    messages: messages // set locale messages
});
